// extracted by mini-css-extract-plugin
module.exports = {"connectPoint":"ConnectPointsWrapper_connectPoint__1cjwg","acceptPoint":"ConnectPointsWrapper_acceptPoint__qgB0q"};